import validate from "/builds/the-eastern-polygon/web/node_modules/nuxt/dist/pages/runtime/validate.js";
import route_45categories_45global from "/builds/the-eastern-polygon/web/middleware/route-categories.global.ts";
export const globalMiddleware = [
  validate,
  route_45categories_45global
]
export const namedMiddleware = {}